import { useRegisterActions } from 'kbar';
import { useTheme } from 'next-themes';
import { useTranslations } from 'next-intl';

const useThemeSwitching = () => {
  const { theme, setTheme } = useTheme();
  const t = useTranslations('navigation.kbar');

  const toggleTheme = () => {
    setTheme(theme === 'light' ? 'dark' : 'light');
  };

  const themeAction = [
    {
      id: 'toggleTheme',
      name: t('toggleTheme'),
      shortcut: ['t', 't'],
      section: t('theme'),
      perform: toggleTheme
    },
    {
      id: 'setLightTheme',
      name: t('setLightTheme'),
      section: t('theme'),
      perform: () => setTheme('light')
    },
    {
      id: 'setDarkTheme',
      name: t('setDarkTheme'),
      section: t('theme'),
      perform: () => setTheme('dark')
    }
  ];

  useRegisterActions(themeAction, [theme, t]);
};

export default useThemeSwitching;
